'use strict';

import React from 'react'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'

import Modal from '@Modal/Modal'

import FormElement from '@/Form/toolkit/FormElement'
import FileInput   from '@/Form/toolkit/FileInput'
import Form        from '@/Form/toolkit/Form'

import { handleChange } from '@/Form/Functions/eventsHandling'

import _ from 'lodash'

const numeral = window.numeral;

numeral.locale('en');

const moment = window.moment;

export default class ShippingDeliveryModal extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			open: false,
			data: { }
		};

		this.handleClose      = this.handleClose.bind(this);
		this.open             = this.open.bind(this);
		this.getDeliveryNotes = this.getDeliveryNotes.bind(this);

		this.handleChange = handleChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'open__ShippingDeliveryModal',
			cb: component.open
		});

		component.setState(
		{
			open: false,
			created: undefined,
			error: undefined,
			data: []
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'open__ShippingDeliveryModal',
			cb: component.open
		});
	}

	handleClose (e, force)
	{
		const component = this, props = this.props;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			data: { }
		});
	}

/**
 *	data:
 *	{
 * 		order_id:       order id
 * 		shipping_id:    shipping id
 * 	}
 **/
	open (data)
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			order_id: data.order_id,
			shipping_id: data.shipping_id
		});
	}

	render (e)
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		let delivery_notes = component.getDeliveryNotes(state.data);

		let output =
		(
			<Modal className="o-modal o-modal--large" open={ component.state.open }
				hide_close={ true } title="Traitement de commandes"
				onClose={ component.handleClose }>

				<Form className={ 'shipping-modal-form' } action="/shipping/create"
					hide_button={ true } data={ component.state.form_data }
					onValidate={ component.handleValidate }
					onError={ component.handleFailure }
					onSubmit={ component.handleSubmit }>

					{ delivery_notes }

					<div className="c-dialog__buttons">
						<button type="button" className="c-btn c-dialog__cancel u-margin-right-0"
							onClick={ component.handleClose }>
							Fermer
						</button>
					</div>

				</Form>

				{ loader }

			</Modal>
		);

		return output;
	}

	getDeliveryNotes (shipping)
	{
		const component = this, props = this.props, state = this.state;

		if (!state.order_id || !state.shipping_id) return null;

		let delivery_notes =
		(
			<div className="u-full-width u-center">

				<a className="c-btn c-btn--small u-margin-top-5"
					key={ state.data.order_id } target="_blank" type="application/pdf"
					href={ '/bon-de-livraison/' + state.order_id + '/' + state.shipping_id }>
					Afficher le bon de livraison
				</a>

			</div>
		);

		return delivery_notes;
	}
}
